import type { Run } from "./IntegrationTestsView";

export function TestStandards() {
  return (
    <details className="pa-test-standards">
      <summary>
        오류 판정 기준 보기 · 수량 차이·요청 실패·기준 초과 1건부터 오류
      </summary>
      <p>
        DB·Redis·주문/취소 장부는 수량 1개 차이, 중복 주문 1건부터 오류입니다.
        재고는 요청 처리가 끝난 뒤 대조합니다.
      </p>
      <p>
        현재 테스트 지연 기준: 목록·API 묶음/장바구니/채팅 ACK 1초, 채팅
        연결/구매 완료/취소/셀러 기능/재입고 대기 3초, 영상 다운로드 5초. 기준을
        넘긴 요청 1건부터 오류로 남습니다. 평균과 P95는 참고값입니다.
      </p>
      <p>
        예기치 않은 채팅 끊김, 미확정 주문, 영상 구간 갱신 정지(구간 길이의 3배
        또는 10초 중 큰 값 초과)도 오류입니다. 영상 디코딩·브라우저 화면의
        끊김은 자동 측정 범위에 포함되지 않습니다.
      </p>
      <p>
        선택했지만 실행되지 않은 기능은 미검증입니다. 테스트 중지·실행 종료와
        검증 통과는 별도로 표시하며, 과거 지연 측정값이 없는 기록은 통과로
        판정하지 않습니다.
      </p>
      <p>
        정상 세션 갱신·셀러 차단에 따른 채팅 종료와 사용자 정지로 중단된 채팅은
        별도로 집계합니다. 이미 확인된 실패는 정지해도 유지됩니다.
      </p>
    </details>
  );
}

export function RunAssessment({ run }: { run: Run }) {
  const assessment = run.assessment;
  const labels: Record<string, string> = {
    error: "오류 감지",
    passed: "검증 통과",
    checking: "검사 중",
    unverified: "미검증 항목 있음",
  };
  return (
    <div
      className={`pa-test-assessment pa-test-assessment-${assessment?.status || "unverified"}`}
      role={assessment?.status === "error" ? "alert" : "status"}
    >
      <strong>
        {labels[assessment?.status || "unverified"] || "판정 대기"}
      </strong>
      {!!assessment?.issues.length && (
        <ul>
          {assessment.issues.map((issue) => (
            <li key={issue.key}>{issue.message}</li>
          ))}
        </ul>
      )}
      {!!assessment?.unchecked.length && (
        <p>아직 확인되지 않은 항목: {assessment.unchecked.join(", ")}</p>
      )}
      {(!assessment || ["cancelled", "interrupted"].includes(run.state)) && (
        <p>전체 검증이 끝나지 않은 실행입니다.</p>
      )}
    </div>
  );
}
